import React from 'react'
import Links from '../../constants'

import { RouteNames } from '../../../../router'
import { Logo, HGooglePlayButton, HAppStoreButton } from '../../../../assets/svgs/landingV2/guest'
import { HIPhone } from '../../../../assets/images/landingV2/guest'
import './styles.scss'
import './responsiveStyles.scss'

function Header() {
  return (
    <div className='gl_header'>
      <div className='gl_header__top'>
        <div className='gl_header__top_logo'>
          <a href='/'>
            <img src={Logo} alt='Pinka logo' />
          </a>
        </div>
        <div className='gl_header__top_buttons'>
          <a href={RouteNames.FOR_BUSINESS}>
            Для кав&apos;ярень
          </a>
        </div>
      </div>
      <div className='gl_header__content'>
        <div className='gl_header__content_left'>
          <h2>Любиш каву?</h2>
          <h1>Замовляй онлайн, отримуй без черг, прокачуй рівень і отримуй знижки</h1>
          <p>
            Завантажуй Pinka, знаходь топові кав’ярні, роби замовлення через застосунок, забирай своє замовлення без
            черг та очікування.
          </p>
          <div className='gl_header__content_left_buttons'>
            <a href={Links.linkToGooglePlay}>
              <img src={HGooglePlayButton} alt='Google play' />
            </a>
            <a href={Links.linkToAppStore}>
              <img src={HAppStoreButton} alt='App store' />
            </a>
          </div>
        </div>
        <div className='gl_header__content_right'>
          <img src={HIPhone} alt='IPhone 14' />
        </div>
      </div>
    </div>
  )
}

export default Header
